const extensionRegExp = /(?:\.([^.]+))?$/

export const replaceStorageByCdn = (url?: string) => {
  if (!url) {
    return undefined
  }
  if (url.includes('https://storage.googleapis.com/ffrdr/')) {
    return url.replace('https://storage.googleapis.com/ffrdr/', 'https://cdn.fishfriender.com/')
  }
  if (url.includes('https://storage.googleapis.com/ffrdr-statics/')) {
    return url.replace('https://storage.googleapis.com/ffrdr-statics/', 'https://statics.fishfriender.com/')
  }
  if (url.includes('https://storage.googleapis.com/ffrdr-staging/')) {
    return url.replace('https://storage.googleapis.com/ffrdr-staging/', 'https://cdn-staging.fishfriender.com/')
  }
  if (url.includes('https://storage.googleapis.com/ffrdr-dev/')) {
    return url.replace('https://storage.googleapis.com/ffrdr-dev/', 'https://cdn-dev.fishfriender.com/')
  }
  return url
}

export const getCDNUrl = (
  media: any,
  size: 'extra_small' | 'small' | 'medium' | 'original',
  seo?: { name?: string; type: 'brandLogo' | 'fishSpecies' | 'contestCover' | 'contestLogo' | 'contestWatermark' }
) => {
  if (!media) {
    return null
  }

  if (['extra_small'].includes(size) && media.url_100) {
    return replaceStorageByCdn(media.url_100)
  }
  if (['extra_small', 'small'].includes(size) && media.url_300) {
    return replaceStorageByCdn(media.url_300)
  }
  if (['extra_small', 'small', 'medium'].includes(size) && media.url_600) {
    return replaceStorageByCdn(media.url_600)
  }
  if (['extra_small', 'small', 'medium', 'original'].includes(size) && media.url) {
    return replaceStorageByCdn(media.url)
  }

  const mediaFormat = extensionRegExp.exec(media.url_100 || media.url_300 || media.url_600 || media.url)[1]

  if (!media.id || !mediaFormat) {
    if (['extra_small'].includes(size) && media.url_100) {
      return media.url_100
    }
    if (['extra_small', 'small'].includes(size) && media.url_300) {
      return media.url_300
    }
    if (['extra_small', 'small', 'medium'].includes(size) && media.url_600) {
      return media.url_600
    }
    if (['extra_small', 'small', 'medium', 'original'].includes(size) && media.url) {
      return media.url
    }
    return null
  }

  if (seo && seo.name) {
    let seoName
    switch (seo.type) {
      case 'brandLogo':
        seoName = `gear-brand-${seo.name}-logo`
        break
      case 'fishSpecies':
        seoName = `fish-species-${seo.name}`
        break
      case 'contestCover':
        seoName = `contest-${seo.name}`
        break
      case 'contestLogo':
        seoName = `contest-${seo.name}-logo`
        break
      case 'contestWatermark':
        seoName = `contest-${seo.name}-watermark`
        break
      default:
        seoName = seo.name
    }
    return `/cdn/images/ffr/${media.id}.${seoName}.${mediaFormat}?size=${size}`
  }
  return `/cdn/images/ffr/${media.id}.${mediaFormat}?size=${size}`
}
